import { api } from "utils";
import { PUBLIC_V1 } from "constant/URL";
import { objectToQueryParams } from "utils/objectToQueryParams";

// Get list of lead primaries with optional query parameters
export const getLeadPrimaries = async (params) => {
  const newParams = (!!params && typeof params === "object") ? `?${objectToQueryParams(params)}` : ""
  return api({}, true).get(`/${PUBLIC_V1}/lead_primaries${newParams}`)
}

// Get single lead primary by ID
export const getLeadPrimary = async (leadId) => {
  return api({}, true).get(`/${PUBLIC_V1}/lead_primaries/${leadId}`)
}

// Update lead primary by ID
export const updateLeadPrimary = async (leadId, data) => {
  return api({}, true).put(`/${PUBLIC_V1}/lead_primaries/${leadId}`, data)
}

// Create new lead primary
export const createLeadPrimary = async (data) => {
  return api({}, true).post(`/${PUBLIC_V1}/lead_primaries`, data)
}

// Create comment for lead primary
export const createLeadComment = async (leadId, data) => {
  return api({}, true).post(`/${PUBLIC_V1}/lead_primaries/${leadId}/create_comment`, data)
}

// Legacy functions (keeping for backward compatibility)
export const tandaiMenanggapi = async (leadId) => {
  return api({}, true).put(`/${PUBLIC_V1}/lead-managements/${leadId}`)
}

export const getListManagement = async (params) => {
  const newParams = (!!params && typeof params === "object") ? `${objectToQueryParams(params)}` : ""
  return api({}, true).get(`/${PUBLIC_V1}/leads?${newParams}`)
}

// Export lead trackers report
export const exportLeadTrackers = async (params) => {
  const newParams = (!!params && typeof params === "object") ? `?${objectToQueryParams(params)}` : ""
  return api({}, true, { responseType: 'arraybuffer' }).get(`/${PUBLIC_V1}/reportings/lead-trackers${newParams}`)
}